import React from "react";
import { Label } from "@fluentui/react-northstar";
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";
import textConstants from "../../../constants/text-constants";

const VerifiedLabel = observer((props) => {
  const { verified, testId } = props;
  const color = verified ? "green" : "yellow";
  const text = verified ? textConstants.VERIFIED : textConstants.UNVERIFIED;

  return (
    <Label
      circular
      className="verified-label"
      color={color}
      content={text}
      data-testid={"verifiedLabel" + testId}
    />
  );
});

VerifiedLabel.propTypes = {
  verified: PropTypes.bool,
  testId: PropTypes.string,
};

VerifiedLabel.defaultProps = {
  verified: false,
  testId: "",
};

export default VerifiedLabel;
